let constants = {
  colorRange: {
    outOfRisk: '#41C99F',
    middleRisk: '#F3B119',
    higherRisk: '#CC5660',
    good: '#41C99F',
    medium: '#F3B119',
    bad: '#CC5660',
    default: '#666'
  },
  taskManagerStateColorRange: {
    ABIERTA: '#F3B119',
    CERRADA: '#41C99F',
    'CERRADA VENCIDA': '#9535a1',
    VENCIDA: '#CC5660',
    default: '#666',
    CLOSED_EXPIRED: '#9535a1',
    EXPIRED: '#CC5660',
    default: '#666',
    CLOSED: '#41C99F',
    OPEN: '#F3B119',
    OVERDUE: '#CC5660',
    CLOSEDOVERDUE: '#9535a1',
    ANNULLED: '#ABACAC',
    NOTIFICATION: '#0095FD',
    PENDINGRECLASIFICATION: '#ABACAC'
  },
  taskManagerStates: {
    open: 'open',
    closed: 'closed',
    closed_expired: 'closed_expired',
    expired: 'expired',
    overdue: 'overdue',
    closeoverdue: 'closeoverdue',
    annulled: 'annulled',
    notification: 'notification',
    pendingreclasification: 'pendingreclasification'
  },
  taskManagerPvtRejectedReasonsBreathalyser: {
    'PVTOPENWORKINGSHIFTGROUPBREATHALYSER': true,
    'PVTSTRUCTUREWORKINGSHIFTGROUPBREATHALYSER': true,
  },
  taskManagerPvtRejectedReasonsForm: {
    'PVTOPENWORKINGSHIFTGROUPFORM': true,
    'PVTSTRUCTUREWORKINGSHIFTGROUPFORM': true,
  },
  taskManagerTabs: {
    TAB_TASKS: 'TASK_MANAGER_TAB_TASKS',
    TAB_NOTIFICATIONS: 'TASK_MANAGER_TAB_NOTIFICATIONS',
    TAB_DETAIL_TASK: 'TAB_DETAIL_TASK',
  },
  tostrOptions: {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: 'toast-top-right',
    preventDuplicates: false,
    showDuration: '300',
    hideDuration: '1000',
    timeOut: '5000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
  },
  periodReportTypes: {
    lastDataReport: '1',
    lastWeekReport: '2',
    lastMonthReport: '3',
    lastThreeMonthsReport: '4',
    lastSixMonthsReport: '5',
    lastYearReport: '6',
    customize: '7'
  },
  toursKeys: {
    driverFatigue: 'DRIVER_FATIGUE',
    driverRoadWarning: 'DRIVER_ROAD_WARNING',
    summaryPvtResults: 'SUMMARY_PVT_RESULTS',
    summaryPvtRealization: 'SUMMARY_PVT_REALIZATION',
    summaryPvtLastResults: 'SUMMARY_PVT_LAST_RESULTS',
    taskManager: 'TASK_MANAGER',
    summarySleepResults: 'SUMMARY_SLEEP_RESULTS',
    summarySleepSync: 'SUMMARY_SLEEP_SYNC',
    summarySleepLastResults: 'SUMMARY_SLEEP_LAST_RESULTS',
    summaryBehavior: 'SUMMARY_BEHAVIOR',
    detailBehavior: 'DETAIL_BEHAVIOR',
    driverBehavior: 'DRIVER_BEHAVIOR'
  },
  dashboard: {
    taskIndicatorsRefreshTime: 10000 * 60 * 2
  },
  ubicationPVT: 'UbicationPVT',
  localStorage: {
    redirectData: 'redirectData',
    tasksManagerDetailData: 'tasksManagerDetailData'
  },
  pageTitles: {
    authorization: 'Faltan-permisos',
    summary_fatigue: 'Biocompatibilidad_Resumen',
    detail_fatigue: 'Biocompatibilidad_Detalle',
    driver_fatigue: 'Biocompatibilidad_Conductor',
    summary_roadwarning: 'Evento-de-fatiga_Resumen',
    detail_roadwarning: 'Evento-de-fatiga_Detalle',
    driver_roadwarning: 'Evento-de-fatiga_Conductor',
    summary_behaviour: 'Conducta_Resumen',
    detail_behaviour: 'Conducta_Detalle',
    driver_behavior: 'Conducta_Conductor',
    summary_truck: 'Flota_Resumen',
    summary_inspections: 'Inspecciones_Resumen',
    detail_inspection: 'Inspecciones_Detalle',
    summary_ffd_pvt: 'Cognus_Resumen',
    last_data_ffd_pvt: 'Cognus_Resultados',
    summary_ffd_sleep: 'Fitness-for-duty_Pulsera-de-sueno_Resumen',
    last_data_ffd_sleep: 'Fitness-for-duty_Pulsera-de-sueno_Resultados',
    detail_waiting_times: 'Tiempos-de-espera_Detalle',
    tasks_manager_detail: 'Gestionador_WhatsApp',
    tasks_manager: 'Gestionador',
    flow_admin_rca_reports: 'Reportes-RCA',
    flow_admin_detail: 'Gestion-de-flujos_Administracion',
    flow_applicant_detail: 'Gestion-de-flujos_Detalle',
    flows_history: 'Gestion-de-flujos_Historial',
    reports: 'Reportes',
    account_list: 'Gestion-de-datos_Lista-dinamica',
    account_driver: 'Gestion-de-datos_Conductores',
    homologation_driver: 'Gestion-de-datos_Conductores-desconocidos',
    account_vehicle: 'Gestion-de-datos_Vehiculos',
    homologation_vehicle: 'Gestion-de-datos_Vehiculos-desconocidos',
    account_semi_trailer: 'Gestion-de-datos_Ramplas',
    homologation_semi_trailer: 'Gestion-de-datos_Ramplas-desconocidas',
    account_working_shift_group: 'Gestion-de-datos_Grupos-de-turno',
    account_geozone: 'Gestion-de-datos_Geozonas',
    account_tag: 'Gestion-de-datos_Categorias',
    account_setting: 'Gestion-de-datos_Configuracion-cliente',
    account_user: 'Gestion-de-datos_Cuentas-de-usuarios',
    account_extended_property: 'Gestion-de-datos_Propiedades-extendidas',
    user_profile: 'Usuario_Perfil',
    summary_nfa: 'Nivel-de-fatiga_Resumen',
    detail_nfa: 'Nivel-de-fatiga_Detalle',
    driver_nfa: 'Nivel-de-fatiga_Conductor',
    assignment_list: 'Asignacion_Listado-de-asignacion',
    allocator: 'Asignacion_Asignador',
    summary_fulfillment: 'Cumplimiento_Resumen',
    detail_fulfillment: 'Cumplimiento_Detalle',
    driver_fulfillment: 'Cumplimiento_Conductor'
  },
  allowedExtensions: [
    '.pdf',
    '.jpeg',
    '.jpg',
    '.png',
    '.gif',
    '.mp4',
    '.mov',
    '.avi',
    '.mpeg',
    '.mpg'
  ],
};

export default constants;



// WEBPACK FOOTER //
// ./source/client/containers/function/constants.js